module.exports = __webpack_public_path__ + "static/media/landingbg.b94b96c8.png";